import { createSelector } from '@ngrx/store';
import { RidersState } from '../reducers/riders.reducer';
import { RiderDTO } from '../../commons/models/riders';
import { selectRidersState, selectTenantState } from '../reducers';
import { TenantState } from '../reducers/tenant.reducers';

export const getRidersTableState = createSelector(
    selectRidersState,
  (state: RidersState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getRiders = createSelector(
    selectRidersState,
  (state: RidersState) => state.list
);

export const getTotalRiders = createSelector(
    getRidersTableState,
  (tableState) => tableState.total
);

export const getRidersCurrentPage = createSelector(
    getRidersTableState,
  (tableState) => tableState.currentPage
);

export const getRidersPerPage = createSelector(
    getRidersTableState,
  (tableState) => tableState.perPage
);

export const getRidersDirection = createSelector(
    getRidersTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
    getRidersTableState,
  (tableState) => tableState.filters
);

export const getRiderDialogId = createSelector(
    selectRidersState,
  (state: RidersState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
    selectRidersState,
  (state: RidersState) => state.selectionDialogId
);

// Selettore per ottenere selectedTenantId da TimeSlotsState
export const selectSelectedTenantId = createSelector(
    selectRidersState,
  (state: RidersState) => {
    //console.log('selectedTenantId:', state.selectedTenantId); 
    return state.selectedTenantId
  }
);

export const selectTenantName = createSelector(
  selectTenantState,
  selectSelectedTenantId,
  (tenantState: TenantState, selectedTenantId: number) => {
    //console.log('TenantState:', tenantState);
    const tenant = tenantState.list.find(t => t.id === selectedTenantId);
    return tenant ? tenant.name : null;
  }
);

export const getSelectedRidersCurrentPage = createSelector(
    selectRidersState,
  (state: RidersState) => {
    const selectedHours = (state.selectedRiders || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedHours.includes(bl.id));
  }
);